import script from "./ModalAsideHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalAsideHeader.vue?vue&type=script&lang=ts&setup=true"

import "./ModalAsideHeader.vue?vue&type=style&index=0&id=7e97d442&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e97d442"]])

export default __exports__